<script>
import { extend } from 'sk-ui/lib/utils/util.js'
import { getAvailableHeight } from 'sky-engine/utils/dom'
import formController from 'sky-engine/views/formController'
import { createViewVNode } from 'sky-engine/views/ViewManager'

import ptFormView from '../../../../../../store/modules/deliveryDeployMng/metaData/deliveryDeployForm'

import { createProject, editProject, getDefaultProductVersion } from '@/api/deliveryProject'
import { getIndustryList } from '@/api/setting'

export default {
  name: 'SkyDeployStepViewCreateProject',
  components: {
    formController
  },
  props: {
    projectId: {
      type: String
    },
    projectState: {
      type: String,
      default: null
    }
  },
  methods: {
    updateAvailableHeight() {
      this.$refs.SkyDeployStepViewCreateProject.availableHeight = getAvailableHeight(this.$el) + this._rem2px(55)
    },
    getData() {
      return {
        dataChange: false,
        busDATA: {}
      }
    },
    updateData() {
      getIndustryList().then(res => {
        var list = res.data.content.itemArr
        var changeList = []
        for (const iterator of list) {
          changeList.push({
            id: iterator.id,
            value: iterator.id,
            label: iterator.industryName
          })
        }

        this.$refs.SkyDeployStepViewCreateProject.view.content[0].$options = changeList
        if (this.projectId != null) {
          this.$refs.SkyDeployStepViewCreateProject.view.content[0].$el = {
            class: 'wsp-custom-edit-industry-disabled',
            disabled: true
          }
        }
      })
    },
    getDefaultProductVersion() {
      getDefaultProductVersion().then(res => {
        this.$refs.SkyDeployStepViewCreateProject.view.content[8].$el.defaultValue = res.data.content.productVersion
      })
    },

    async saveStep() {
      let result = false

      await this.$refs.SkyDeployStepViewCreateProject.formRef.validate(valid => {
        result = valid
      })
      if (!result) {
        this.$store.dispatch('OpenNotification', { message: '表单存在必填项未填写，请确认', type: 'error' })
        return false
      }
      var from_data = this.$refs.SkyDeployStepViewCreateProject.$refs.renderForm.value
      if (!result) {
        return false
      }

      // from_data.salesId = from_data.salesIdLabel.id
      // from_data.presalesId = from_data.presalesIdLabel.id
      if (from_data.presalesIdLabel) {
        from_data.presalesId = from_data.presalesIdLabel.id
      }
      // from_data.salesLeader = from_data.salesLeaderLabel.id
      from_data.postsalesIdList = []
      from_data.postsalesIdLabelList.forEach(element => {
        from_data.postsalesIdList.push(element.id)
      })
      from_data.salesLeaderIdList = []
      from_data.salesLeaderLabelList.forEach(item => {
        from_data.salesLeaderIdList.push(item.id)
      })

      if (this.projectId) {
        from_data.id = this.projectId
        await editProject(from_data).then(res => {
          this.$emit('changeProjectId', {
            projectId: this.projectId,
            customer: from_data.customer,
            industryId: from_data.industryId
          })
          result = false
        })
      }

      return result
    },
    async gotoNextPreVliate() {
      return true
    },
    async gotoNextStep() {
      let result = false

      await this.$refs.SkyDeployStepViewCreateProject.formRef.validate(valid => {
        result = valid
      })

      var from_data = this.$refs.SkyDeployStepViewCreateProject.$refs.renderForm.value

      if (!result) {
        this.$store.dispatch('OpenNotification', { message: '还有必填项未填写，请检查！', type: 'error' })
        return false
      }

      if (from_data.presalesIdLabel) {
        from_data.presalesId = from_data.presalesIdLabel.id
      }
      from_data.postsalesIdList = []
      from_data.postsalesIdLabelList.forEach(element => {
        from_data.postsalesIdList.push(element.id)
      })
      from_data.salesLeaderIdList = []
      from_data.salesLeaderLabelList.forEach(item => {
        from_data.salesLeaderIdList.push(item.id)
      })
      if (this.projectId) {
        from_data.id = this.projectId
        await editProject(from_data)
          .then(res => {
            this.$emit('changeProjectId', {
              projectId: this.projectId,
              customer: from_data.customer,
              industryId: from_data.industryId
            })
          })
          .catch(e => {
            result = false
          })
      } else {
        await createProject(from_data)
          .then(res => {
            this.$emit('changeProjectId', {
              projectId: res.data.content,
              customer: from_data.customer,
              industryId: from_data.industryId
            })
          })
          .catch(e => {
            result = false
          })
      }
      return result
    },
    gotoPreStep() {
      return false
    }
  },
  created() {
    this.updateData()
    if (!this.projectId) {
      this.getDefaultProductVersion()
    }
  },
  data() {
    const ptFormViewCopy = extend(true, {}, ptFormView)
    ptFormViewCopy.toolbar = {
      hasToolbar: false
    }
    if (this.projectId) {
      ptFormViewCopy.params = {
        id: this.projectId
      }
      ptFormViewCopy.needFetchFillInfo = true

      this.$emit('showBtns', {
        preStep: false,
        nextStep: true,
        saveStep: false,
        enableTabChange: false,
        enableSkipNext: false
      })
    } else {
      ptFormViewCopy.view.content[1].$el = {}
      ptFormViewCopy.view.content[6].$el = {}
      this.$emit('showBtns', {
        preStep: false,
        nextStep: true,
        saveStep: false,
        enableTabChange: false,
        enableSkipNext: false
      })
    }
    ptFormViewCopy.ref = 'SkyDeployStepViewCreateProject'
    const metaView = ptFormViewCopy

    return {
      metaView: metaView
    }
  },
  render(h) {
    return createViewVNode(this.metaView, h)
  }
}
</script>
